import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useDaysAgoIndication = (): ((daysAgo: number | null | undefined, translationKey: string) => string) => {
  const { t } = useTranslation()

  return useCallback(
    (daysAgo: number | null | undefined, translationKey: string): string => {
      if (daysAgo === null || daysAgo === undefined) {
        return ''
      }

      if (daysAgo === 0) {
        return t(translationKey, { ago: t('common.today') })
      }
      if (daysAgo === 1) {
        return t(translationKey, { ago: t('common.yesterday') })
      }
      if (daysAgo >= 61) {
        return t(translationKey, { ago: `${Math.floor(daysAgo / 31)} ${t('common.months')} ${t('common.ago')}` })
      }
      if (daysAgo >= 31) {
        return t(translationKey, { ago: `${Math.floor(daysAgo / 31)} ${t('common.month')} ${t('common.ago')}` })
      }
      if (daysAgo >= 14) {
        return t(translationKey, { ago: `${Math.floor(daysAgo / 7)} ${t('common.weeks')} ${t('common.ago')}` })
      }
      if (daysAgo >= 7) {
        return t(translationKey, { ago: `${Math.floor(daysAgo / 7)} ${t('common.week')} ${t('common.ago')}` })
      }
      return t(translationKey, { ago: `${daysAgo} ${t('common.days')} ${t('common.ago')}` })
    },
    [t]
  )
}
